import { IRecordFurtherEducationGroupNode, RecordFurtherEducationGroupNode } from "../recordFurtherEducationGroup/recordFurtherEducationGroupNode";

export interface IRecordFurtherEducationNode {
    id: string;
    groupId: string;
    code: string;
    comment: string;
    scopeUnit: number;
    scope: number;
    validity: number;
    parent: IRecordFurtherEducationGroupNode;

    parentIsCollapsed(): boolean;
}

export class RecordFurtherEducationNode implements IRecordFurtherEducationNode {
    id: string;
    groupId: string;
    code: string;
    comment: string;
    scopeUnit: number;
    scope: number;
    validity: number;
    parent: RecordFurtherEducationGroupNode;

    constructor();
    constructor(obj: IRecordFurtherEducationNode);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.groupId = obj && obj.groupId || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.scopeUnit = obj && obj.scopeUnit || 0;
        this.scope = obj && obj.scope || 0;
        this.validity = obj && obj.validity || 0;
        this.parent = obj && obj.parent || null;
    }

    parentIsCollapsed(): boolean {
        if (!this.parent) return false;
        return this.parent.collapsed;
    }
}